module.exports = __webpack_public_path__ + "img/house-chimney-heart.a11fb96c.svg";